<template>
  <div style="margin: 10px">
    <!-- <el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<div class="introBox" @click="getChild(item.id)" v-for="(item,index) in introList" >
						<span class="bTextOne">{{item.columname}}</span>
						<div :class="['boxBottom',index == 0 ?'bottomOne':index % 2 == 0 ?'bottomTwo':'bottomThree'] "></div>
					</div>
				</el-card>
			</el-col>
		</el-row> -->
    <el-row style="margin-top: 10px">
      <el-col :span="24">
        <el-card class="box-card">
          <h4>网站信息</h4>

          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="数据看板:" prop="title">
              <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="看板1" name="first">
                  <el-form-item>
                    <el-input
                      v-model="form.title1"
                      style="width: 30%"
                      placeholder="请输入您的标题"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.number1"
                      style="width: 30%"
                      placeholder="请输入您要展示的数字"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-upload
                      drag
                      action=""
                      :limit="1"
                      list-type="picture-card"
                      :on-success="getUrl1"
                      :before-upload="beforeUrl1"
                      :file-list="fileList1"
                      :on-exceed="handleUrl"
                    >
                      <i class="el-icon-picture-outline"></i>
                      <br />
                      <span class="uploadTip">将图片拖到此处，或点击上传</span>
                    </el-upload>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="看板2" name="second">
                  <el-form-item>
                    <el-input
                      v-model="form.title2"
                      style="width: 30%"
                      placeholder="请输入您的标题"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.number2"
                      style="width: 30%"
                      placeholder="请输入您要展示的数字"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-upload
                      drag
                      action=""
                      :limit="1"
                      list-type="picture-card"
                      :on-success="getUrl2"
                      :file-list="fileList2"
                      :on-exceed="handleUrl"
                      :before-upload="beforeUrl2"
                    >
                      <i class="el-icon-picture-outline"></i>
                      <br />
                      <span class="uploadTip">将图片拖到此处，或点击上传</span>
                    </el-upload>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="看板3" name="third">
                  <el-form-item>
                    <el-input
                      v-model="form.title3"
                      style="width: 30%"
                      placeholder="请输入您的标题"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.number3"
                      style="width: 30%"
                      placeholder="请输入您要展示的数字"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-upload
                      drag
                      action=""
                      :limit="1"
                      list-type="picture-card"
                      :before-upload="beforeUrl3"
                      :file-list="fileList3"
                      :on-exceed="handleUrl"
                    >
                      <i class="el-icon-picture-outline"></i>
                      <br />
                      <span class="uploadTip">将图片拖到此处，或点击上传</span>
                    </el-upload>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="看板4" name="fourth">
                  <el-form-item>
                    <el-input
                      v-model="form.title4"
                      style="width: 30%"
                      placeholder="请输入您的标题"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.number4"
                      style="width: 30%"
                      placeholder="请输入您要展示的数字"
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-upload
                      drag
                      action=""
                      :limit="1"
                      list-type="picture-card"
                      :before-upload="beforeUrl4"
                      :file-list="fileList4"
                      :on-exceed="handleUrl"
                    >
                      <i class="el-icon-picture-outline"></i>
                      <br />
                      <span class="uploadTip">将图片拖到此处，或点击上传</span>
                    </el-upload>
                  </el-form-item>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>

            <el-form-item label="选择图片:">
              <div>
                <el-upload
                  drag
                  action=""
                  :limit="1"
                  list-type="picture-card"
                  :on-success="getUrl"
                  :file-list="fileList"
                  :on-exceed="handleUrl"
                  :before-upload="beforeUrl"
                >
                  <i class="el-icon-picture-outline"></i>
                  <br />
                  <span class="uploadTip">将图片拖到此处，或点击上传</span>
                </el-upload>
                <div slot="tip" class="el-upload__tip">
                  请图片小于3M(jpg、png、bmp)<br />尺寸不可小于200*200px
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <!-- <editor
                id="editor_id"
                height="500px"
                width="1200px"
                :content.sync="editorText"
                :afterChange="afterChange()"
                pluginsPath="../../../static/kindeditor/plugins/"
                :loadStyleMode="false"
                @on-content-change="onContentChange"
              ></editor> -->
              <editor
                v-model="form.detail"
                :isClear="isClear"
                @change="change"
              ></editor>
            </el-form-item>
            <el-form-item>
              <input
                type="button"
                @click="onSubmit"
                class="submit"
                value="提交"
              />
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import E from 'wangeditor'
// import EditorBar from '../../../components/editor.vue'
import Editor from "@/components/tinymce";
import qs from 'qs'
export default {
  components: {
    Editor,
  },
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        detail: '',
        id: '',
        title1: '',
        number1: '',
        pic1: '',
        title2: '',
        number2: '',
        pic2: '',
        title3: '',
        number3: '',
        pic3: '',
        title4: '',
        number4: '',
        pic4: ''
      },
      editor: null,
      editorContent: '',
      isClear: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      filePic: '',
      editorText: '', // 双向同步的变量
      editorTextCopy: '', // content-change 事件回掉改变的对象
      activeName: 'first'
    }
  },
  mounted () { },
  created () {
    this.getData()
  },
  methods: {
    onContentChange (val) {
      this.form.detail = val
    },
    afterChange () { },
    change (val) { },
    // 获取简介
    getData () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/show/index/get',
        params: {}
      }).then((res) => {
        if (res.data.status == 200) {
          this.fileList.push({
            url: this.settings.apiBaseImg + res.data.data.images
          })
          this.filePic = res.data.data.images
          this.form.detail = res.data.data.describe
          this.form.id = res.data.data.id
          this.form.title1 = res.data.data.bordOneTitle
          this.form.title2 = res.data.data.bordTwoTitle
          this.form.title3 = res.data.data.bordThreeTitle
          this.form.title4 = res.data.data.bordFourTitle
          this.form.number1 = res.data.data.bordOneNumber
          this.form.number2 = res.data.data.bordTwoNumber
          this.form.number3 = res.data.data.bordThreeNumber
          this.form.number4 = res.data.data.bordFourNumber

          if (res.data.data.bordOneIco != '') {
            this.fileList1.push({
              url: res.data.data.bordOneIco
            })
          }
          if (res.data.data.bordTwoIco != '') {
            this.fileList2.push({
              url: res.data.data.bordTwoIco
            })
          } if (res.data.data.bordThreeIco != '') {
            this.fileList3.push({
              url: res.data.data.bordThreeIco
            })
          } if (res.data.data.bordFourIco != '') {
            this.fileList4.push({
              url: res.data.data.bordFourIco
            })
          }
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforeUrl (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.fileList = []
          this.filePic = res.data.data.url
          this.fileList.push({
            url: res.data.data.url
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforeUrl1 (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.fileList1 = []
          this.form.pic1 = res.data.data.url
          this.fileList1.push({
            url: res.data.data.url
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforeUrl2 (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.fileList2 = []
          this.form.pic2 = res.data.data.url
          this.fileList2.push({
            url: res.data.data.url
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforeUrl3 (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.fileList3 = []
          this.form.pic3 = res.data.data.url
          this.fileList3.push({
            url: res.data.data.url
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforeUrl4 (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.fileList4 = []
          this.form.pic4 = res.data.data.url
          this.fileList4.push({
            url: res.data.data.url
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    getUrl (file, fileList) {
      this.fileList = []
      this.fileList.push({
        url: this.settings.apiBaseUrl + file.data.fileName
      })
      this.filePic = file.data.fileName
    },
    getUrl1 (file, fileList) {
      this.fileList1 = []
      this.fileList1.push({
        url: this.settings.apiBaseUrl + file.data.fileName
      })
      this.form.pic1 = file.data.fileName
    },
    getUrl2 (file, fileList) {
      this.fileList2 = []
      this.fileList2.push({
        url: this.settings.apiBaseUrl + file.data.fileName
      })
      this.form.pic2 = file.data.fileName
    },
    getUrl3 (file, fileList) {
      this.fileList3 = []
      this.fileList3.push({
        url: this.settings.apiBaseUrl + file.data.fileName
      })
      this.form.pic3 = file.data.fileName
    },
    getUrl4 (file, fileList) {
      this.fileList4 = []
      this.fileList4.push({
        url: this.settings.apiBaseUrl + file.data.fileName
      })
      this.form.pic4 = file.data.fileName
    },
    handleUrl (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onSubmit () {
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/show/index/update',
        data: {
          id: this.form.id,
          images: this.filePic,
          describe: this.form.detail,
          bordOneTitle: this.form.title1,
          bordOneNumber: this.form.number1,
          bordOneIco: this.form.pic1,
          bordTwoTitle: this.form.title2,
          bordTwoNumber: this.form.number2,
          bordTwoIco: this.form.pic2,
          bordThreeTitle: this.form.title3,
          bordThreeNumber: this.form.number3,
          bordThreeIco: this.form.pic3,
          bordFourTitle: this.form.title4,
          bordFourNumber: this.form.number4,
          bordFourIco: this.form.pic4
        }
      }).then((res) => {
        if (res.data.status == 200) {
          obj.$message.success('修改成功')
        } else {
          obj.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
.introBox {
  width: 319px;
  height: 127px;
  background: #ffffff;
  box-shadow: -1px -4px 6px 1px rgba(0, 0, 0, 0.17);
  border-radius: 15px;
  float: left;
  margin-right: 35px;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.boxBottom {
  width: 319px;
  height: 36px;
  border-radius: 0px 0px 15px 15px;
  position: absolute;
  bottom: 0;
}

.bottomOne {
  background: #f3ac9c;
}

.bottomTwo {
  background: #8896f6;
}

.bottomThree {
  background: #76b67e;
}

.bTextOne {
  width: 83px;
  height: 19px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 24px;
  color: #f3ac9c;
  display: block;
  margin: 0 auto;
  padding-top: 30px;
}

.bTextTwo {
  width: 83px;
  height: 19px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 24px;
  color: #8896f6;
  display: block;
  margin: 0 auto;
  padding-top: 30px;
}

.bTextThree {
  width: 83px;
  height: 19px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 24px;
  color: #76b67e;
  display: block;
  margin: 0 auto;
  padding-top: 30px;
}

.uploadBtn {
  width: 146px;
  height: 33px;
  background: #ffffff;
  box-shadow: 4px 4px 6px 1px rgba(0, 0, 0, 0.13);
  border-radius: 3px;
  border: 1px solid #ffffff;
  color: #5eb4eb;
}

.uploadBtn:hover {
  color: #ffffff;
  background: #5eb4eb;
  border: 1px solid #5eb4eb;
}

/deep/ .el-upload__tip {
  float: left;
  width: 219px;
  height: 19px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  opacity: 0.4;
  margin-bottom: 20px;
}

.submit {
  width: 91px;
  height: 33px;
  background: #8896f6;
  box-shadow: 3px 2px 7px 1px rgba(0, 0, 0, 0.34);
  border-radius: 5px;
  border: 1px solid #8896f6;
  color: #ffffff;
  float: right;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-bottom: 1px solid #e4e7ed;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #554de6;
  color: #ffffff;
  border-bottom-color: #554de6;
}

/deep/.el-form-item .el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/content/introduction/introduction.vue